import React from 'react'

import { Container, Row, Col, Image } from 'components/qstrap'
import Paper from 'components/atoms/Paper'
import Typography from 'components/atoms/Typography'

import { number, string } from 'prop-types'

const EnrollmentStepCard = ({
  no,
  title,
  children,
}) => (
  <>
    <div className="dots"/>
    <Paper>
      <div className="enrollment-steps__item">
        <div className="enrollment-steps__item-icon">
          <Image src={`/assets/img/kit-landing/icons/enroll-${no}.svg`} alt={`Enrollment KIT Cambodia - ${title} | Quipper Campus`}/>
          <Typography component="p" variant="body" className="enrollment-steps__item-no">
            Tahap {no}
          </Typography>
          <Typography component="h3" variant="headline">
            {title}
          </Typography>
          { children }
        </div>
      </div>
    </Paper>
  </>
)

EnrollmentStepCard.propTypes = {
  no: number,
  title: string,
}

const EnrollmentSteps = () => (
  <div id="enrollment-steps" className="enrollment-steps">
    <Container>
      <Typography component="h2" variant="title" className="enrollment-steps__title text-center">
        Informasi Pendaftaran
      </Typography>
      <Typography component="p" variant="body" className="text-center">
        Ikuti pendaftarannya langsung secara online. Cek informasinya di sini:
      </Typography>
      <div className="enrollment-steps__major">
        <Typography component="h2" variant="headline" className="text-center">
          Software Engineering
        </Typography>
      </div>
      <hr/>
      <div className="enrollment-steps__section">
        <Row className="d-flex a-i-stretch ">
          <Col md="3">
            <EnrollmentStepCard
              no={1}
              title="Pendaftaran Online"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Cukup klik <br/>
                  “Daftar Sekarang”
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={2}
              title="Tes Masuk Online"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  - Matematika <br/>
                  - Tes IQ <br/>
                  - English Proeficiency Test (EPT)
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={3}
              title="Wawancara Online"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Wawancara akan dilakukan dalam Bahasa Inggris satu minggu setelah tes
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={4}
              title="Letter of Acceptance"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Jika lulus, kamu akan mendapatkan LoA sekitar satu minggu setelah menyelesaikan seluruh tes.
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
        </Row>
      </div>
      <div className="separator"/>
      <div className="enrollment-steps__major">
        <Typography component="h2" variant="headline" className="text-center">
          International Leaders Hospitality Management
        </Typography>
      </div>
      <hr/>
      <div className="enrollment-steps__section">
        <Row className="d-flex a-i-stretch ">
          <Col md="3">
            <EnrollmentStepCard
              no={1}
              title="Pendaftaran Online"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Cukup klik <br/>
                  “Daftar Sekarang”
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={2}
              title="Tes Masuk Online"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  - Tes IQ
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={3}
              title="Wawancara Online & Tes EQ"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Wawancara akan dilakukan dalam Bahasa Inggris satu minggu setelah tes
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
          <Col md="3">
            <EnrollmentStepCard
              no={4}
              title="Letter of Acceptance"
            >
              <div className="enrollment-steps__item-desc">
                <Typography component="p" variant="body">
                  Jika lulus, kamu akan mendapatkan LoA sekitar satu minggu setelah menyelesaikan seluruh tes.
                </Typography>
              </div>
            </EnrollmentStepCard>
          </Col>
        </Row>
      </div>
    </Container>
  </div>
)

export default EnrollmentSteps
